<template>
    <customer-dashboard-layout id="cdb-index-profile">
        <section id="cdb-index-navigation" class="d-flex justify-content-center">
            <div class="col-12 col-md-6 col-lg-4">
                <div class="row mb-4">
                    <div class="col-6 col-lg-7 col-xl-6">
                        <h1 class="mb-0">{{ $t('cdb.profile.title') }}</h1>
                    </div>
                    <div class="col-6 col-lg-5 col-xl-6 d-flex justify-content-end">
                        <b-button variant="link" :to="$getUrl('cdb-dashboard')">
                            {{ $t('cdb.profile.subscription') }}
                        </b-button>
                    </div>
                </div>

                <div class="mb-4">
                    <div class="col-12 mb-4">
                        <h3 class="mb-0">{{ $t('cdb.profile.personal_data') }}</h3>
                    </div>

                    <div class="col-12">
                        <b-form-group
                            :label= "$t('cdb.profile.form.mobile.phone.number.label')"
                            label-for="telephone"
                            v-if="this.$root.whitelabel.isUs()"
                        >
                            <input id="telephone" class="form-control" :placeholder="$t('cdb.profile.form.mobile.phone.number.label')"
                                     type="text" v-model="telephone"/>
                        </b-form-group>

                        <b-form-group
                            :label= "$t('cdb.profile.form.telephonenumber.label')"
                            label-for="telephone"
                            v-else
                        >
                            <input id="telephone" class="form-control" :placeholder="$t('cdb.profile.form.telephonenumber.filler')"
                                     type="text" v-model="telephone"/>
                        </b-form-group>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-12 mb-4">
                        <h3 class="mb-0">{{ $t('cdb.profile.account_details') }}</h3>
                    </div>

                    <!-- <div class="col-12 mb-3" v-show="locales.length > 1">
                        <div class="mb-2">
                            <b-form-group :label="$t('cdb.profile.languageLabel')">
                                <b-form-select v-model="locale" :options="locales"></b-form-select>
                            </b-form-group>
                        </div>
                    </div> -->

                    <div class="col-12">
                        <div class="alert alert-warning mb-3">
                            <div class="mb-2">
                                <span><b>{{ $t('cdb.profile.warning_text.title') }}</b></span>
                            </div>

                            {{ $t('cdb.profile.warning_text.text') }}
                        </div>
                    </div>

                    <div class="col-12">
                        <b-form-group :label="$t('cdb.profile.form.email.label')" label-for="email">
                            <input id="email" class="form-control" :placeholder="$t('cdb.profile.form.email.filler')"
                                type="text" v-model="email" />
                        </b-form-group>

                        <b-form-group :label="$t('cdb.profile.form.email_repeat.label')" label-for="email">
                            <input id="email_confirmation" class="form-control"
                                :placeholder="$t('cdb.profile.form.email_repeat.filler')" type="email"
                                v-model="email_confirmation" />
                        </b-form-group>
                    </div>

                    <div class="col-12">
                        <b-form-group :label="$t('cdb.profile.form.password.label')" label-for="password">
                            <input id="password" class="form-control" :placeholder="$t('cdb.profile.form.password.filler')"
                                type="password" v-model="password" />
                        </b-form-group>
                    </div>

                    <div class="col-12 mb-5">
                        <b-form-group :label="$t('cdb.profile.form.password_repeat.label')"
                            label-for="password_confirmation">
                            <input id="password_confirmation" class="form-control"
                                :placeholder="$t('cdb.profile.form.password_repeat.filler')" type="password"
                                v-model="password_confirmation" />
                        </b-form-group>
                    </div>

                    <div class="col-12">
                        <button type="button" class="btn btn-primary" @click="handleChangeProfile" block>{{
                            $t('cdb.profile.save_changes') }}</button>
                    </div>

                    <div class="col-12 mt-3" v-if="!activeAbos">
                        <button class="btn btn-outline-danger" @click.native="showDelAccountModal = true" block>
                            {{ $t('cdb.profile.delete_account') }}
                        </button>
                    </div>
                </div>
            </div>
        </section>

        <section id="modals">
            <b-modal v-model="showDelAccountModal" hide-footer id="delAccount"
                :title="$t('cdb.profile.delete_account.title')">
                <p class="my-3">{{ $t('cdb.profile.delete_account.text') }}</p>
                <div class="row d-flex justify-content-center">
                    <button class="btn btn-secondary mx-2" @click="showDelAccountModal = false">{{
                        $t('cdb.profile.delete_account.abort') }}</button>
                    <button class="btn btn-danger mx-2">{{ $t('cdb.profile.delete_account') }}</button>
                </div>
            </b-modal>

            <b-modal v-model="showSuccessModal" :title="$t('cdb.profile.save.title')" ok-only header-text-variant="success">
                {{ $t('cdb.profile.save.success') }}
            </b-modal>

            <b-modal v-model="showErrorModal" :title="$t('cdb.profile.warning.title')" ok-only
                header-text-variant="warning">
                <div class="row m-2">{{ $t('cdb.profile.save.warning') }}</div>
                <div v-if="error" class="row m-2 text-danger">
                    <span v-for="errorMessage in error">{{ $t(errorMessage) }}<br /></span>
                </div>
            </b-modal>
        </section>

    </customer-dashboard-layout>
</template>

<script>
import CustomerDashboardLayout from "../../layouts/CustomerDashboardLayout.vue";
import { BFormGroup, BFormSelect, BModal, BButton } from 'bootstrap-vue'

export default {
    components: {
        CustomerDashboardLayout,
        BModal,
        BFormGroup,
        BFormSelect,
        BButton
    },

    data() {
        return {
            telephone: '',
            firstname: '',
            lastname: '',
            birthday: this.minimumAge,
            email: this.$root.user.state.data.email,
            email_confirmation: this.$root.user.state.data.email,
            password: '',
            password_confirmation: '',
            activeAbos: true,
            showDelAccountModal: false,
            showSuccessModal: false,
            showErrorModal: false,
            error: [],
            locale: '',
        }
    },
    computed: {
        // temporary disabled
        // locales() {
        //     let locales = []
        //     let { languages } = this.$root.whitelabel.state.settings
        //     languages.forEach(language => {
        //         const label = language.split('_')[0].toUpperCase()

        //         // frontend workaround because i18n somehow can't handle underscores coming from partner dashboard
        //         const vueI18nValue = language.replace('_', '-')
        //         locales.push({
        //             value: vueI18nValue,
        //             text: this.$t(`languages.${label}`)
        //         })
        //     })
        //     return locales
        // },
    },

    methods: {
        handleChangeProfile() {
            this.$axios.get('/sanctum/csrf-cookie').then(() => {
                this.$axios.put(`api/v1/profile/update_customer`, {
                    uuid: this.$root.user.state.data.faaren_uuid,
                    telephone: this.telephone,
                    email: this.email,
                    email_confirmation: this.email_confirmation,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                    locale: this.locale
                })
                    .then((data) => {
                        this.$root.initWhitelabel();
                        
                        if(data.data.success === 'redirect') {
                            this.$goTo('account_not_verified')
                        } else {
                            if (data.data.success != true) {
                                this.showErrorModal = true;
                            } else {
                                this.showSuccessModal = true;
                            }
                        }
                    }).catch(error => {
                        this.showErrorModal = true;

                        if(error.response.data.errors.email){
                            error.response.data.errors.email.forEach(error => {
                                this.error.push(error)
                            }) 
                        }

                        if(error.response.data.errors.password){
                            error.response.data.errors.password.forEach(error => {
                                this.error.push(error)
                            }) 
                        }

                        clearTimeout(this.errorTimer);
                        this.errorTimer = setTimeout(() => {
                            this.error = '';
                        }, 10000);

                    });
            });
        },

        loadInfo() {
            this.$axios.get('/sanctum/csrf-cookie').then(() => {
                this.$axios.get(`api/v1/profile/get_profile_data`).then((res) => {
                    const { telephone, first_name, last_name, birthday, locale } = res.data

                    this.telephone = telephone
                    this.firstname = first_name
                    this.lastname = last_name
                    this.birthday = new Date(birthday)
                    this.locale = locale
                });
            });
        },
    },

    created() {
        this.loadInfo();
    },

    head: {
        title: function () {
            return {
                inner: this.$root.whitelabel.state.settings.meta_title,
                complement: this.$t('meta.cdbProfile.title')
            }
        },
        meta: function () {
            return [
                { name: 'description', content: this.$t('meta.cdbProfile.description') }
            ]
        }
    }
}
</script>
